import React from "react";
import { Link } from "react-router-dom";
import { Alert, Button, Nav, Navbar, NavbarText, NavItem } from "reactstrap";
import { version } from '../../../../package.json'

type Props = Readonly<{
  jobTitle: string | null;
  review: boolean;
  showProductionAlert: boolean;
  title: string;
  toggleSidebar: () => void;
}>;

export const Navigation = ({
  jobTitle,
  review,
  showProductionAlert,
  title,
  toggleSidebar,
}: Props) => {
  return (
    <Navbar color="dark" dark>
      <Nav style={{alignItems:"center"}}>
        <NavItem className="mr-4">
          <Button color="light" disabled={review} onClick={toggleSidebar} outline type="button">
            <i className="fa fa-bars" />
          </Button>
        </NavItem>
        {review ? (
          <span className="navbar-brand" title={title}>
            {title}
          </span>
        ) : (
          <Link className="navbar-brand" to="/" title={title}>
            {title}
          </Link>
        )}
          <span
            style={{
                borderRadius:"6px",
                border:"1pt solid white",
                fontSize:"15px",
                color:"white",
                height:"15px",
                padding:"10px",
                marginRight:"15px",
                lineHeight:0
              }}
            >
              v{version}
          </span>
      </Nav>
      {jobTitle && (
        <NavbarText className="border-left border-white pl-3 text-white" title={jobTitle}>
          {jobTitle}
        </NavbarText>
      )}
      <Nav className="ml-auto">
        <NavItem>
          <Alert color="warning" className="mb-0" fade isOpen={showProductionAlert}>
            <i className="fa fa-warning mr-2" />
            <strong>
              This job has been marked to help train the predictive models. Please ensure a high
              level of accuracy.
            </strong>
          </Alert>
        </NavItem>
      </Nav>

    </Navbar>
  );
};
Navigation.displayName = "Navigation";
